module.exports = __webpack_public_path__ + "media/images/lb/725-f300c0c44c6c3a36c4dd2cd2e1ed2647.svg";